module.exports = __webpack_public_path__ + "img/RCA.cdc54dc4.png";